var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#083d7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032f61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df1e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc162c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.857143v4.571429h-6.857143z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.142857 6.857143h6.857143v4.571429h-6.857143z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6.857143h6.857143v4.571429h-6.857143z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.142857 0h6.857143v4.571429h-6.857143z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85714286 4.57142857h-6.85714286v2.28571429h6.85714286v4.57142854h2.28571428v-4.57142854h6.85714286v-2.28571429h-6.85714286v-4.57142857h-2.28571428z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 4.57142857c-.63118257 0-1.14285714.51167458-1.14285714 1.14285714 0 .63118257.51167457 1.14285715 1.14285714 1.14285715.63118255 0 1.14285714-.51167458 1.14285714-1.14285715",
    fill: "#c93127",
    fillOpacity: 0.2,
    mask: "url(#e)",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -1.697465 7.33053)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5.714286,
    fill: "#042f60",
    mask: "url(#e)",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.80812206 6.52240775c-.44631353.44631348-1.16993059.44631348-1.61624409 0-.44631348-.44631348-.44631348-1.16993059 0-1.61624407l.26937401.26937401c-.29754232.29754232-.29754232.77995373 0 1.07749605.29754231.29754231.77995373.29754231 1.07749606 0 .29754232-.29754232.29754232-.77995373 0-1.07749605l.26937402-.26937401c.44631344.44631348.44631344 1.16993059 0 1.61624407zm0 0c-.44631353.44631348-1.16993059.44631348-1.61624409 0-.44631348-.44631348-.44631348-1.16993059 0-1.61624407l.26937401.26937401c-.29754232.29754232-.29754232.77995373 0 1.07749605.29754231.29754231.77995373.29754231 1.07749606 0 .29754232-.29754232.29754232-.77995373 0-1.07749605l.26937402-.26937401c.44631344.44631348.44631344 1.16993059 0 1.61624407z",
    fill: "#0f6d1a",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/DO.0f069e0308925ba8237e138f682b66ae.svg";
export { ForwardRef as ReactComponent };